import * as React from 'react';
import { Select } from 'antd';
import { Contract } from 'tree-wallet-client';
import { GlobalContext } from '../../Contexts/GlobalContext';

const { Option } = Select;

interface MenuContractSelectorProps{
}

interface MenuContractSelectorState{
  loading: boolean;
}

export default class MenuContractSelector extends React.Component<MenuContractSelectorProps, MenuContractSelectorState>{
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  constructor(props: MenuContractSelectorProps) {
    super(props);
    this.onContractChange = this.onContractChange.bind(this);
    this.state = {
      loading: false,
    }
  }

  onContractChange(contractIndex: any) {
    const { contracts } = this.context;
    this.context.updateState && this.context.updateState({
      contract: contracts && contracts[contractIndex]
    });
  }

  render() {
    const { contracts } = this.context;

    return (
      <>
        <Select
          placeholder={'Select a contract'}
          onChange={this.onContractChange}
          style={{ width: '100%' }}
          defaultValue={0}
        >
          {contracts && contracts.map((value: Contract, index: number) => {
            return <Option value={index} key={value.description}>{value.description}</Option>;
          })}
        </Select>
      </>
    );
  }
}